import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

// Subscriptions process
import personalSituationCircles from "./subscriptions/PersonalSituationCircles"
application.register("personal-situation", personalSituationCircles)
import newSubscription from "./subscriptions/NewSubscription"
application.register("new-subscription", newSubscription)

// General Components
import enableFormSubmit from "./enableFormSubmit"
application.register("enable-form-submit", enableFormSubmit)
import dropzone from "./dropzone_controller"
application.register("dropzone", dropzone)


// Documents
import documentFormController from "./documents/document_form_controller"
application.register("document-form", documentFormController)
import fiscDocumentFormController from "./documents/fisc_document_form_controller"
application.register("fisc-document-form", fiscDocumentFormController)

// Buy Offers
import buyOffersAmountController from "./buy_offers/buy_offer_amount_controller"
application.register("buy-offer-amount", buyOffersAmountController)